/**
 * @author lokendra.chouhan
 * @Date: 2022-10-12 16:00:00
 * @Last Modified by: lokendra
 * @Last Modified time: 2020-10-12 16:00:00
 */

import { func, array, bool, shape, string, number } from 'prop-types';

/**
 * @class Booking
 */

const BookingDefaultProps = {
  isBankCard: false,
  voucherType: '',
  email: '',
  phone: '',
  client_series: '',
  defaultVariationType: [],
};

const BookingProps = {
  visibility: bool.isRequired,
  isBankCard: bool,
  isShowValidation: bool.isRequired,
  email: string,
  quantity: number.isRequired,
  clientid: string.isRequired,
  phone: string,
  voucherType: string,
  client_series: string,
  default_select: string.isRequired,
  cardData: shape({}).isRequired,
  validators: shape({}).isRequired,
  variationObj: shape({}).isRequired,
  GiftCardContact: shape({}).isRequired,
  variations: array.isRequired,
  variation_types: array.isRequired,
  defaultVariationType: array,
  handleChildActions: func.isRequired,
  _childUpdateValidators: func.isRequired,
  onSetProductContactUs: func.isRequired,
};

export { BookingDefaultProps, BookingProps };



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/giftCardProductDataHandler.js